module.exports = __webpack_public_path__ + "img/IT0000161613905.af8af744.png";